import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { DynamicStatus } from "@prisma/client";
import StatusDropdown from "components/signals/processPage/StatusDropdown";
import _ from "lodash";
import moment from "moment";
import React from "react";

interface Props {
  row: SQLGeneratedProcess;
}

export default function Status({ row }: Props): JSX.Element | null {
  if (!row.statusLabel || !row.statusColor || !row.statusId) {
    return null;
  }

  const status: Pick<DynamicStatus, "label" | "color" | "id"> = {
    label:
      row.statusLabel === "Open"
        ? `Open for ${moment.duration(new Date().getTime() - row.created_at.getTime()).humanize()}`
        : _.capitalize(row.statusLabel ?? ""),
    color: row.statusColor,
    id: row.statusId,
  };
  return (
    <div className="w-fit" onClick={(e) => e.stopPropagation()}>
      <StatusDropdown processId={row.id} status={status} workflowId={row.workflowId} size={"SMALL"} type="BUTTON" />
    </div>
  );
}
